import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Container from "@mui/material/Container";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TranslatedText from "./TranslatedText";

import "../Styles/QuestionAnswer.css";

export default function SimpleAccordion() {
  return (
    <div>
      <div className="activ-item-heading">
        <h4 className="heading-h4">
          <TranslatedText defaultText="Актуальні питання" />
        </h4>
        <h3 className="questions-heading">
          <TranslatedText defaultText="Колективний захист та інші формальності"></TranslatedText>{" "}
        </h3>
        <hr className="active-rule" />
      </div>
      <div className="accordion-box">
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="1. Реєстраційні центри для українських біженців в Норвегії." />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="
                  
                  Шукачі притулку можуть пройти реєстрацію у кількох місцях
                  За загальним правилом, шукачі притулку повинні зареєструватися в Національному центрі
                  реєстрації в Східному поліцейському окрузі. Біженці з України, які збираються подати заявку на
                  отримання захисту, також можуть зареєструватися в п'яти інших місцях країни: Кіркенес,
                  Тронхейм, Берген, Ярен і Торп. У більшості випадків вам потрібно зв’язатися з поліцією, щоб
                  узгодити час для реєстрації (external website).
                  Реєстрація в округах є обмеженою. Якщо округ, куди ви прибули, не має можливості
                  зареєструвати вас, то вас буде доставлено до Національного центру реєстрації.
                  
"
                />
              </h5>
              <a
                className="contact-a"
                href="https://www.udi.no/uk/information-ukraine-and-russia/situation-in-ukraine/arrival-in-norway/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="2. Хто може отримати колективний захист в Норвегії." />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="Українці можуть отримати колективний захист у Норвегії. Докладніше про те, хто
                  може отримати колективний захист читайте тут.
                  
"
                />
              </h5>
              <a
                className="contact-a"
                href="https://www.udi.no/uk/information-ukraine-and-russia/situation-in-ukraine/stay-in-norway/
                protection-asylum-in-norway/want-to-apply-rights-and-obligations/
                "
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="3.  Kолективний захист" />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="Надання колективного захисту означає, що Директорат у справах іноземців (UDI) не
                  розглядає необхідність у захисті в індивідуальному порядку, а надає усім
                  українцям, що втекли від війни в Україні, а також членам їх сімей, колективний
                  захист. Таким чином забезпечується прискорення надання допомоги українцям.
                  Дозвіл на колективний захист має обмежений термін дії та видається на один рік з
                  можливістю продовження на термін, у сукупності не більше трьох років.
                  Колективний захист не дає підстав для отримання дозволу на постійне проживання
                  протягом перших трьох років. Після закінчення трьох років ви можете отримати
                  тимчасовий дозвіл на проживання, який дає підстави для подальшого отримання
                  дозволу на постійне проживання. Директорат у справах іноземців (UDI) розгляне
                  заявку індивідуально
                  Українці, які отримують колективний захист, не отримують статусу біженця та
                  посвідчення біженця
"
                />
              </h5>
              <a
                className="contact-a"
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="4.Чи можна поїхати в іншу країну після отримання колективного захисту?" />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="Так, ви можете виїжджати за межі Норвегії, якщо у вас є колективний захист.
                  Зверніть увагу, що ви повинні перебувати в Норвегії принаймні половину часу
                  терміну дії вашого дозволу.
                  Збираючись виїхати за кордон вам необхідно мати:
                  • дійсний закордонний паспорт/ паспорт іммігранта/ проїзний документ для біженців
                  • дійсну посвідку на проживання
                  Якщо у вас немає дійсного паспорта або дійсної посвідки на проживання, вам не
                  слід виїжджати з Норвегії. У вас можуть виникнути проблеми в аеропорту, при в’їзді
                  в іншу країну або при поверненні назад до Норвегії.
                  Саме посвідка на проживання підтверджує, що ви маєте дозвіл на проживання в
                  Норвегії.
                  За прикордонний контроль відповідає поліція. Директорат у справах іноземців (UDI)
                  не може відповісти на запитання про те, як здійснюється прикордонний контроль у
                  Норвегії чи інших країнах. Ми також не надаємо письмові підтвердження, які можна
                  використовувати для подорожей і які буде прийнято авіакомпаніями чи органами
                  влади інших країн. Таким чином, усі подорожі без посвідки на проживання
                  здійснюватимуться на власний ризик."
                />
              </h5>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="5. Як я можу сконтактувати з Директоратом у справах іноземців (UDI)?" />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="+47 21 49 32 84
                  Графік роботи: 09.00 - 15.00 з понеділка по п'ятницю.
                  Ми можемо надати інформацію про окремі випадки лише тоді, коли особа телефонує або
                  перебуває на місці, або якщо ви отримали письмовий дозвіл від відповідної особи.
                  
"
                />
              </h5>
              <a
                className="contact-a"
                href="https://www.udi.no/kontakt-oss/personer-som-har-sporsmal-relatert-til-ukraina/?suk=1
                "
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="6. Що робити якщо закінчився термін дії закордонного паспорту." />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="Замовити новий паспорт можна в Посольстві України яке знаходиться в м. Осло.
                  Потрібний попередній запис для оформлення документів.
                  Посольство приймає громадян лише за попереднім онлайн-записом."
                />
              </h5>
              <a
                className="contact-a"
                href=" https://online.mfa.gov.ua/application
                "
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання для реєстрації:" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>

        <h3 className="questions-heading">
          <TranslatedText defaultText="Охорона здоров'я та екстрена допомога:"></TranslatedText>{" "}
        </h3>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="1. Як дзвонити в служби порятунку в Норвегії." />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText defaultText="101 пожежна допомога" />
                <br></br>
                <TranslatedText defaultText="102 поліція" />
                <br></br>
                <TranslatedText defaultText="103 швидка медична допомога" />
              </h5>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="2. Як укладається договір з лікарем загальної практики?" />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="На даний момент в Норвегії декілька реєстраційних центрів де можна зареєструватися на
отримання колективного захисту.
"
                />
              </h5>
              <a
                className="contact-a"
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="3. Реєстраційні центри для українських біженців в Норвегії." />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="На даний момент в Норвегії декілька реєстраційних центрів де можна зареєструватися на
отримання колективного захисту.
"
                />
              </h5>
              <a
                className="contact-a"
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="4. Реєстраційні центри для українських біженців в Норвегії." />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="На даний момент в Норвегії декілька реєстраційних центрів де можна зареєструватися на
отримання колективного захисту.
"
                />
              </h5>
              <a
                className="contact-a"
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
        <h3 className="questions-heading">
          <TranslatedText defaultText="Діти, сім'я і школа"></TranslatedText>{" "}
        </h3>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="1. Дитячий садок в Норвегії" />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="На даний момент в Норвегії декілька реєстраційних центрів де можна зареєструватися на
отримання колективного захисту.
"
                />
              </h5>
              <a
                className="contact-a"
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="2. Школа в Норвегії" />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="На даний момент в Норвегії декілька реєстраційних центрів де можна зареєструватися на
отримання колективного захисту.
"
                />
              </h5>
              <a
                className="contact-a"
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="3. Дозвілля дітей шкільного віку " />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="На даний момент в Норвегії декілька реєстраційних центрів де можна зареєструватися на
отримання колективного захисту.
"
                />
              </h5>
              <a
                className="contact-a"
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="4. Управління захисту дітей та прав дитини" />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="На даний момент в Норвегії декілька реєстраційних центрів де можна зареєструватися на
отримання колективного захисту.
"
                />
              </h5>
              <a
                className="contact-a"
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>

        <h3 className="questions-heading">
          <TranslatedText defaultText="Наші домашні тварини"></TranslatedText>{" "}
        </h3>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="1. Що робити з моїм домашнім улюбленцем під час реєстрації?" />
            </h3>
          </AccordionSummary>
          <AccordionDetails
            sx={{ backgroundColor: "#eee", textAlign: "center" }}
          >
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="Якщо ви привезли свою домашню тварину з-за кордону, Норвезьке управління з
                  безпеки харчових продуктів повинно оглянути тварину на кордоні . Якщо ваша домашня
                  тварина не була перевірена Норвезьким управлінням безпеки харчових продуктів на
                  кордоні після вашого прибуття, то вам потрібно негайно зв’язатися з Норвезьким
                  управлянням безпеки харчових продуктів за телефоном 22 40 00 00. Вони також
                  допоможуть вам з тимчасовим житлом для вашої тварини, поки ви не оселитесь в місці, де
                  ваша тварина зможе жити разом з вами.
                  Докладніше про контроль домашніх тварин з-за кордону можна прочитати на веб-сторінці
                  Норвезького управління з безпеки харчових продуктів (external website). Інформація
                  доступна норвезькою, англійською, українською та російською мовами.
"
                />
              </h5>
              <a
                className="contact-a"
                href="https://www.mattilsynet.no/language/english/animals/travelling_with_pets/pets_from_ukraine.46421"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText=" 2. Як працює ветеринарна служба в Норвегії?" />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="На даний момент в Норвегії декілька реєстраційних центрів де можна зареєструватися на
отримання колективного захисту.
"
                />
              </h5>
              <a
                className="contact-a"
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
        <h3 className="questions-heading">
          <TranslatedText defaultText="Побутові питання"></TranslatedText>{" "}
        </h3>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText="1. Як правильно сортувати сміття?" />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="Чому ми повинні сортувати сміття?
                  Все сміття треба сортувати, це на краще
                  для людей і навколишнього середовища. Відходи, які сортуються
                  відновлюється найкращим можливим способом, наприклад
                  для нових продуктів. У Вестфолді кожен повинен сортувати,
                  згідно з правилами утилізації відходів
                  в окремому муніципалітеті."
                />
              </h5>
              <a
                className="contact-a"
                href="https://www.larvik.kommune.no/vann-vei-og-renovasjon/renovasjon/slik-kildesorterer-du/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h3 className="question-h3">
              <TranslatedText defaultText=" 2. Режим роботи магазинів у Норвегії" />
            </h3>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#eee" }}>
            <Container>
              <h5 className="answer-h5">
                <TranslatedText
                  defaultText="На даний момент в Норвегії декілька реєстраційних центрів де можна зареєструватися на
отримання колективного захисту.
"
                />
              </h5>
              <a
                className="contact-a"
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {
                  <h2 className="link-h2">
                    <TranslatedText defaultText="Посилання" />
                  </h2>
                }
              </a>
            </Container>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}
